import { render } from "./LoaderDoom.vue?vue&type=template&id=011e64fe&scoped=true"
import script from "./LoaderDoom.vue?vue&type=script&lang=js"
export * from "./LoaderDoom.vue?vue&type=script&lang=js"

import "./LoaderDoom.vue?vue&type=style&index=0&id=011e64fe&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-011e64fe"]])

export default __exports__